import { GetGoodsSupplyPriceResponse } from "../../kymw0900/api-services/get-goods-supply-price.service";
import { GetSelectedNvalMediumListResponse } from "../../kymw0900/api-services/get-selected-nval-medium-list.service";

export class KYMW0907InputModel {
  // モード：追加
  public static MODO_ADD = 1;

  // モード：詳細
  public static MODO_DETAIL = 2;

  // モード：閲覧
  public static MODO_READ_ONLY = 3;

  // モード
  public mode: number = 0;

  // 遷移元から受け取る受注コード
  public orderCode = '';

  // 遷移元から受け取るPコード
  public pCode = '';

  // 遷移元から受け取る会員タブのアイテムコードリスト
  public coopInfoItemCode = [];

  // 1物N価詳細情報ID
  public nvalDetailId = '';

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードに紐づく生協コードリスト
  public itemRelatedCoop_CoopTab = [];

  // アイテムコードのリスト
  public itemCodeList = [];

  // 媒体
  public mediumType = '';

  // 媒体リスト
  public mediumTypeList: GetSelectedNvalMediumListResponse[] = [];

  // 注文コード割当
  public nvalOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public nvalOrderNumQuotaCodeList = [];

  // 1物N価詳細区分
  public nvalDetailDev = '';

  // 1物N価詳細区分リスト
  public nvalDetailDevList = [];

  // 商品企画担当区分
  public shkkktantKb = '';

  // 専用商品名
  public nvalPromotionGoodsName = '';

  // 専用商品名(カナ)
  public nvalPromotionGoodsNameKana = '';

  // 専用規格名
  public nvalPromotionStandardName = '';

  // 専用規格名(カナ)
  public nvalPromotionStandardNameKana = '';

  // 注文コード
  public orderNum = '';

  // 値引区分
  public discountType = '0';

  // 値引率
  public discountRate = '';

  // 供給単価
  public supplyPriceStandard = '';
  
  // 値引単価
  public discountUnitPrice = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // 価格パターン 初期値：「0:通常」
  public pricePattern = '0';

  // 価格パターンコンボボックス表示用
  public coopSupplyPriceList: GetGoodsSupplyPriceResponse[] = [];

  // 利用都県:全生協
  public allCoop = false;
  public allCoopDisable = false;

  // 利用都県:い
  public usePrefecture1Flg = false;
  public coopIBDisable = false;

  // 利用都県:と
  public usePrefecture2Flg = false;
  public coopTODisable = false;

  // 利用都県:ぐ
  public usePrefecture3Flg = false;
  public coopGUDisable = false;

  // 利用都県:ち
  public usePrefecture4Flg = false;
  public coopTIDisable = false;

  // 利用都県:さ
  public usePrefecture5Flg = false;
  public coopSADisable = false;

  // 利用都県:とう
  public usePrefecture6Flg = false;
  public coopTKDisable = false;

  // 利用都県:な
  public usePrefecture7Flg = false;
  public coopNADisable = false;

  // 利用都県:に
  public usePrefecture8Flg = false;
  public coopNIDisable = false;

  // 備考
  public remarks = '';

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';

  // kymw0900で空のデータに対して「詳細」で開いたかどうかを確認するフラグ
  public emptyDetailFlg = false;
}
